import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
import { shadowBorder } from './focusVisible';
import { palette2 } from './newPalette';
export var fakeBorder = function (_a) {
    var _b = _a === void 0 ? {} : _a, pseudo = _b.pseudo, _c = _b.inset, inset = _c === void 0 ? true : _c, radius = _b.radius, _d = _b.size, size = _d === void 0 ? 1 : _d, _e = _b.color, color = _e === void 0 ? palette2('highContrast') : _e, allowTransparent = _b.allowTransparent;
    return function (_a) {
        var theme = _a.theme;
        var colorValue = typeof color === 'function' && theme ? color({ theme: theme }) : color;
        if (!allowTransparent && colorValue === 'transparent')
            return;
        if (pseudo) {
            return shadowBorder(radius, colorValue, inset, size);
        }
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      box-shadow: ", " 0 0 0 ", "px ", ";\n    "], ["\n      box-shadow: ", " 0 0 0 ", "px ", ";\n    "])), inset ? 'inset' : '', size, colorValue);
    };
};
var templateObject_1;
